<template>
  <div id="app" :class="[browser.name, browser.os.toLowerCase()]">
    <component :is="layout"/>
    <feedback-box id="box_feedback" v-if="user.id && $route.path != '/' && $route.path != '/pricing'" />
  </div>
</template>

<script>
const { detect } = require('detect-browser');
const browser = detect();
import { mapGetters } from "vuex";
import NoLayout from "@/components/NoLayout";
import FrontLayout from "@/components/FrontLayout";
import AuthLayout from "@/components/AuthLayout";
import LoggedInLayout from "@/components/LoggedInLayout";
import feedbackBox from "@/components/FeedbackBox";
import npsBox from "@/components/NpsBox";
import UuidRandom from "uuid-random";

export default {
  name: "App",
  components: {
    "no-layout": NoLayout,
    "front-layout": FrontLayout,
    "auth-layout": AuthLayout,
    "logged-in-layout": LoggedInLayout,
    feedbackBox,
    npsBox
  },
  data() {
    return {
      browser,
    }
  },
  computed: {
    ...mapGetters(["user"]),
    layout() {
      return this.$store.getters.layout;
    }
  },
  sockets: {
    LESSON_CREATED(msg) {
      if (msg.student_id == this.user.id) {
        this.$store.dispatch('lastLesson').then( lesson => {
          this.$router.push(`/lessons/${lesson.uuid}`)
        });
        this.$toast.open({
          duration: 3000,
          message: `Redirecting to new lesson...`,
          type: "success"
        });
      }
    },
    SOCKET_LESSON_CREATED() {
      // console.log('SOCKET_LESSON_CREATED socket from app.vue')
    }
  },
  mounted() {
    if (this.$route.query && this.$route.query.refreshed) {
      // BYPASS cache
      this.$nextTick(() => {
        const scriptTags = document.querySelectorAll('script[src]');
        const cacheBuster = 'cacheBuster=' + new Date().getTime();

        for (const script of scriptTags) {
          const originalSrc = script.getAttribute('src');
          if (originalSrc[0] === '/') {
            script.remove();

            const newScript = document.createElement('script');
            newScript.src = originalSrc + '?' + cacheBuster;
            document.head.appendChild(newScript);
          }
        }
      })
    }
  },
  created() {
    // PARTNER
    if (this.$route.query.p_aid && !this.$localStorage.get("p_aid")) {
      this.$localStorage.set("pid", this.$route.query.p_aid);
    }

    this.$store.dispatch("setUuid", UuidRandom());

    this.$auth.load()
        .then(() => {
      if (this.$localStorage.get("redirectAfterLogin") == 'undefined') {
        this.$localStorage.set("redirectAfterLogin", null);
      }

      if (this.$auth.check()) {
        if (this.$auth.user()) {
          const user = this.$auth.user();
          this.$store.dispatch("setUser", user);
          this.$mixpanel.identify(user.id+'');
          this.$mixpanel.people.set({
            "$first_name": user.first_name,
            "$email": user.email,
            "$created": user.created_at,
            "$last_login": new Date()
          })
          this.$store.dispatch("setLayout", "logged-in-layout");
        } else {
        }
      }
    }).catch((e) => {
      console.log('USER NOT LOGGED IN')
      console.log({e})
    });
  }
};
</script>

<style lang="scss">
@import "./css/global.scss";
</style>
